import lodash from 'lodash'
import { save } from '../func'
import { cloneDeep } from 'lodash'

const defaultState = {
  keepAliveComponents: [], // names // keepalive的组件
}

const global = {
  namespaced: true,
  state: () => cloneDeep(defaultState),
  getters: {},
  actions: {},
  mutations: {
    save,
    setKeepAliveComponents(state, payload) {
      state.keepAliveComponents = lodash.cloneDeep(payload ?? [])
    },
  },
}

export default global
